import Component from './account_list.vue'
export default Component
